import { action } from "satcheljs/lib/legacy";
import { InstrumentationService, TeamDataService } from "sh-services";
import { UserFREType, UserSettingsEntity } from "sh-models";
import { getGenericEventPropertiesObject } from "sh-instrumentation";

const MAX_RETRY_ATTEMPTS = 3;

/**
 * Adds a list of new FRE type to the fresShownSoFar in user settings
 */

export let setFREsShownSoFar = action("setFREsShownSoFar")(
    async function setFREsShownSoFar(freTypes: UserFREType[]) {
        const userSettings: UserSettingsEntity = await TeamDataService.getUserSettings();
        if (!freTypes || !freTypes.length) {
            return null;
        }
        for (let i = 0; i < freTypes.length; i++) {
            const freType = freTypes[i];
            if (!userSettings.fresShownSoFar) {
                userSettings.fresShownSoFar = [];
            }
            if (userSettings.fresShownSoFar.indexOf(freType) === -1) {
                userSettings.fresShownSoFar.push(freType);
            }
        }

        for (let attempt = 1; attempt <= MAX_RETRY_ATTEMPTS; attempt++) {
            try {
                const result = await TeamDataService.saveUserSettings(userSettings);
                InstrumentationService.logEvent(
                    InstrumentationService.events.SetFREsShownSoFar,
                    [
                        getGenericEventPropertiesObject(InstrumentationService.properties.FreTypes, freTypes.join(","))
                    ]
                );
                return result;
            } catch (error) {
                InstrumentationService.trackException(
                    error,
                    `setFREsShownSoFar_attempt_${attempt}_freTypes_${freTypes.join(",")}`,
                    "setFREsShownSoFar"
                );
                if (attempt < MAX_RETRY_ATTEMPTS) {
                    // Wait before retrying (exponential backoff)
                    await new Promise(resolve => setTimeout(() => resolve(undefined), Math.pow(2, attempt) * 100));
                }
            }
        }
        return null;
    });
